import { useEffect, useState } from 'react';
import useGettingWidgetData from '../../../hooks/useGettingWidgetData';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';
import { Box, Typography } from '@mui/material';
import ORGANIZATION_LOGO_NAME_WidgetLayout from './ORGANIZATION_LOGO_NAME_WidgetLayout';

const ORGANIZATION_LOGO_NAME_Widget = ({ widget, atPublicDashboard = false, password = null }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    const { widgetData, loading } = useGettingWidgetData(widget, atPublicDashboard, password);
    const [organizationName, setOrganizationName] = useState(null);
    const [organizationImage, setOrganizationImage] = useState(null);

    useEffect(() => {
        if (!widgetData) return;
        setOrganizationName(widgetData?.widgetResponse?.organizationName || null);
        setOrganizationImage(widgetData?.widgetResponse?.imagePath || null);
    }, [widgetData]);

    if (loading || !organizationName || !organizationImage) {
        return (
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={120}>
                <Typography>{t('Loading...')}</Typography>
            </Box>
        );
    }

    return (
        <Box className={'OrgAUEPie-container'} //height={`${size}px`} width={`${size}px`}
            display={'flex'} justifyContent={'center'} alignItems={'center'}
        >
            <ORGANIZATION_LOGO_NAME_WidgetLayout
                logoSize={widget?.widgetConfig?.extraFields?.logoSize || 80}
                widgetLayout={widget?.widgetConfig?.extraFields?.widgetLayout || 'logo_name'}
                organizationName={organizationName}
                organizationImage={organizationImage}
            />
        </Box>
    );
};

export default ORGANIZATION_LOGO_NAME_Widget;
